
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/policy-two",
      function () {
        return require("private-next-pages/fr/en/policy-two.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/policy-two"])
      });
    }
  